// extracted by mini-css-extract-plugin
export default {"container":"style_container__yGw-O","tabs":"style_tabs__zo5VB","tabOption":"style_tabOption__nL7Jn"};